import React from "react"
import Box from "@material-ui/core/Box"
import Paper from "@material-ui/core/Paper"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import { DatePicker } from "@material-ui/pickers"
import IconButton from "@material-ui/core/IconButton"
import { makeStyles } from '@material-ui/core/styles';

import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft"
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight"

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: theme.palette.background.paper,
    top: 'auto',
    bottom: 0,
    padding: theme.spacing(1, 2, 1),
  },
  grow: {
    flexGrow: 1,
  },
  picker: {
    width: "100px"
  }
}));

const Datepicker = props => {
  const { date, onClickLeft, onClickRight, onDateChange, datasDisponiveis, dateParse, dateUnparse } = props

  const classes = useStyles();

  const dateIndex = datasDisponiveis.indexOf(date)
  const leftDisabled = (dateIndex === 0)
  const rightDisabled = (dateIndex === datasDisponiveis.length-1)

  return (
    <div>
    <AppBar
    position='fixed'
    className={classes.appBar + ' center'}
    >
      <Toolbar>
        <Box pr={2}>
      <IconButton disabled={leftDisabled} onClick={onClickLeft} size="medium" style={{ outline:"none"}} >
          <KeyboardArrowLeftIcon fontSize="large" />
      </IconButton></Box>
        <DatePicker
        className={classes.picker}
        autoOk
        allowKeyboardControl
        label="Data:"
        format="dd/MM/yyyy"
        shouldDisableDate={(date) => (
          !(datasDisponiveis.includes(dateUnparse(date)))
        )}
        value={dateParse(date)}
        onChange={onDateChange}/>
        <Box pl={2}>
        <IconButton disabled={rightDisabled} onClick={onClickRight} size="medium" style={{ outline:"none"}}>
          <KeyboardArrowRightIcon fontSize="large" />
        </IconButton>
        </Box>
        </Toolbar>
        </AppBar>
        </div>
  )
}

export default Datepicker
